import { useCallback } from 'react';
import { showStaleVersionToast } from './toast';
import { useAppVersionMonitor } from './useAppVersionMonitor';

/**
 * Polls for deployed version updates and shows the reference refresh toast when stale.
 * Render once near the app root when your feature flag is on.
 * Requires react-toastify ToastContainer.
 */
export function AppVersionMonitor(): null {
  const onStaleVersion = useCallback(() => {
    showStaleVersionToast({
      onRefresh: () => window.location.reload(),
    });
  }, []);

  useAppVersionMonitor({
    enabled: true,
    onStaleVersion,
  });

  return null;
}
